import { useContext, useEffect, useMemo } from 'react';
import { useSelector, useStore } from 'react-redux';
import { useAnatomicRegionSynchronyzer } from 'app/providers/AnatomicRegionProvider';
import { isAcquisitionDemo, isAcquisitionTelemetryDemo } from 'app/utils/envUtil';
import { selectConstructorConfiguration } from 'app/redux/constructorConfiguration/reducer';
import { FlatPanelStateContext } from 'app/components/FlatPanelStateProvider';

const DemoFlatPanelAnatomicRegionSynchronizer: React.FC = () => {
  const { anatomicRegion } = useAnatomicRegionSynchronyzer();
  const flatPanelStateContext = useContext(FlatPanelStateContext);
  const constructorConfiguration = useSelector(selectConstructorConfiguration);
  const store = useStore();

  const isDemo = useMemo(
    () => isAcquisitionDemo(store) || isAcquisitionTelemetryDemo(store),
    [constructorConfiguration]
  );
  const detector = flatPanelStateContext?.detectors?.[flatPanelStateContext?.selectedDetectorIndex];

  useEffect(() => {
    if (!isDemo) return;

    if (detector && typeof detector.setCurrentAnatomicRegion === 'function') {
      detector.setCurrentAnatomicRegion(anatomicRegion);
    }
  }, [anatomicRegion, detector, isDemo]);

  return null; // This component does not render anything
};

export default DemoFlatPanelAnatomicRegionSynchronizer;
